<template>
  <div>
    <premium-dashboard />
     <!-- v-if="userRole === 'PREMIUM'" -->
    <!-- <free-dashboard v-if="userRole === 'FREE'" /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PremiumDashboard from "./Premium";
import FreeDashboard from "./Free";

export default {
  name: "Home",
  components: {
    PremiumDashboard,
    FreeDashboard,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    userRole() {
      return this.user ? this.user.role : null
    },
  },
};
</script>
